import * as React from 'react';
export const Option = ({ children, className, value, ...props }) => (React.createElement("option", { className: className, value: value, ...props }, children));
//# sourceMappingURL=option.js.map